"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
exports.useMetadataTrackList = void 0;
var video_context_1 = require("../context/video-context");
var React = __importStar(require("react"));
var react_1 = require("@xstate/react");
var selectors_1 = require("../selectors");
var useMetadataTrackList = function () {
    var videoService = (0, video_context_1.useVideo)();
    var _a = React.useState(true), trackListUpdated = _a[0], setTrackListUpdated = _a[1];
    var textTracks = (0, react_1.useSelector)(videoService, selectors_1.selectTextTracks);
    /**
     * listen to add an remove track events on the {TextTrackList} so we can
     * clear and update the cues accordingly
     */
    React.useEffect(function () {
        function handleTrackChanges() {
            setTrackListUpdated(true);
        }
        if (textTracks) {
            textTracks.addEventListener('change', handleTrackChanges);
            textTracks.addEventListener('addtrack', handleTrackChanges);
            textTracks.addEventListener('removetrack', handleTrackChanges);
        }
        return function () {
            if (textTracks) {
                textTracks.removeEventListener('change', handleTrackChanges);
                textTracks.removeEventListener('addtrack', handleTrackChanges);
                textTracks.removeEventListener('removetrack', handleTrackChanges);
            }
        };
    }, [textTracks]);
    /**
     * monitor the textTracks on the current video element and register
     * any metadata tracks that appear
     */
    React.useEffect(function () {
        if (trackListUpdated) {
            videoService.send({ type: 'CLEAR_METADATA_TRACKS' });
            // {TextTrackList} objects aren't real arrays so you have to
            // convert them accordingly
            var tracks = Array.from(textTracks || []).filter(function (track) {
                return ['metadata'].includes(track.kind);
            });
            tracks.forEach(function (track) {
                videoService.send({ type: 'ACTIVATE_METADATA_TRACK', track: track });
            });
        }
        setTrackListUpdated(false);
    }, [videoService, textTracks, trackListUpdated]);
};
exports.useMetadataTrackList = useMetadataTrackList;
